<template>
  <div
  class="top_search">
    <h2 class="filters-title">Search:</h2>
    <el-input
      placeholder="Search the Receivable's reference or Customer"
      v-model="searchQuery"
      class="searchbar"
      @keyup.native="sendQuery">
      <el-button
        slot="append"
        icon="close"
        v-if="searchQuery !== ''"
        @click="clearSearchQuery">
        Clear search
      </el-button>
    </el-input>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default{
  data() {
    return {
      searchQuery: '',
      timer: '',
    };
  },
  computed: {
    ...mapGetters({
      getReceivablesSearchQuery: 'getReceivablesSearchQuery',
    }),
  },
  mounted() {
    this.searchQuery = this.getReceivablesSearchQuery;
  },
  methods: {
    ...mapActions({
      setReceivablesSearchQuery: 'setReceivablesSearchQuery',
      getSearchedReceivableTransactionsData: 'getSearchedReceivableTransactionsData',
    }),
    sendQuery() {
      window.clearTimeout(this.timer);
      const query = this.searchQuery;
      this.timer = window.setTimeout(() => {
        if (query === this.searchQuery) {
          this.setReceivablesSearchQuery(this.searchQuery);
          this.getSearchedReceivableTransactionsData();
        }
      }, 500);
    },
    clearSearchQuery() {
      this.searchQuery = '';
      this.setReceivablesSearchQuery(this.searchQuery);
      this.getSearchedReceivableTransactionsData();
    },
  },
};
</script>

<style lang="scss" scoped>
.top_search {
  margin: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  .searchbar-input{
    padding-left: 10px;
  }
  .form-control {
    border-radius: 0;
  }
  .input-group-btn {
    button {
      border-radius: 3px;
    }
  }
}
.purchase-orders-summary {
  .searchbar {
    margin: 0;
    flex: 2;
    padding-left: 10px;
  }
}
.searchbar {
  width: 93%;
}
</style>



// WEBPACK FOOTER //
// src/components/receivables/partials/receivables-filters/partials/ReceivablesSearch.vue